import { render, staticRenderFns } from "./board-members.vue?vue&type=template&id=f4d94826&scoped=true&"
import script from "./board-members.vue?vue&type=script&lang=js&"
export * from "./board-members.vue?vue&type=script&lang=js&"
import style0 from "./board-members.vue?vue&type=style&index=0&id=f4d94826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d94826",
  null
  
)

export default component.exports